import React from 'react';
import HeadMeta from '@/components/common/HeadMeta';
import FullAboutUs from '@/components/sections/FullAboutUs';

export default function SobreMi() {
  const metaProps = {
    title: 'Sobre Julie en Entre Coach - Descubre Tu Potencial',
    keywords:
      'Julie Ann De Armas, Entre Coach, Psicología, Coaching Profesional, Bienestar Personal',
    description:
      'Conoce más sobre Julie Ann De Armas en Entre Coach, tu especialista en psicología y coaching, y cómo su enfoque personalizado puede potenciar tu crecimiento personal y profesional.',
  };
  return (
    <>
      <HeadMeta {...metaProps} />
      <FullAboutUs />
    </>
  );
}
